const FRIENDLY_REFINE_ERROR_MESSAGES = Object.freeze({
  "account-required": "Please sign in to create another card.",
  "auth/user-state-not-settled":
    "We could not verify your account session. Please try again in a moment.",
  "auth/missing-id-token-provider":
    "We could not verify your account session. Please try again in a moment.",
  "auth/network-request-failed":
    "We could not verify your account session. Please try again in a moment.",
});

const SAFE_DIAGNOSTIC_CODES = new Set([
  "account-required",
  "auth/missing-id-token-provider",
  "auth/network-request-failed",
  "auth/user-state-not-settled",
]);

const GENERIC_REFINE_ERROR_MESSAGE =
  "We couldn’t create your card yet. Please try again in a moment.";

export function getFriendlyRefineErrorMessage(error = {}) {
  const code =
    typeof error.code === "string" && SAFE_DIAGNOSTIC_CODES.has(error.code)
      ? error.code
      : "";

  if (code === "account-required" && error.reason === "anonymous-generation-limit") {
    return FRIENDLY_REFINE_ERROR_MESSAGES[code];
  }

  return FRIENDLY_REFINE_ERROR_MESSAGES[code] || GENERIC_REFINE_ERROR_MESSAGE;
}

export function getSafeRefineDiagnostic(error, phase) {
  const diagnostic = { phase, category: "unknown" };

  if (
    typeof error?.code === "string" &&
    SAFE_DIAGNOSTIC_CODES.has(error.code)
  ) {
    diagnostic.code = error.code;
  }

  if (
    Number.isInteger(error?.status) &&
    error.status >= 100 &&
    error.status <= 599
  ) {
    diagnostic.status = error.status;
    diagnostic.category =
      error.status >= 500
        ? "server"
        : error.status >= 400
          ? "request"
          : "response";
  }

  return diagnostic;
}
